export const container = `group/categories-toggle-score px-2.5 py-3 rounded border border-solid border-gray-150 flex flex-col data-[is-active="true"]:gap-2`;
